type CallbackFunction = (...args: any[]) => void;

/**
 * 防抖函数（整合节流功能）
 * @param func 需要防抖处理的函数
 * @param wait 时间间隔
 * @param immediate  为 true 表示第一次触发后执行
 */
export const debounce = function debounce<T extends (...args: any[]) => void> (
  callback: T,
  wait: number,
  immediate = false,
) {
  // This is a number in the browser and an object in Node.js,
  // so we'll use the ReturnType utility to cover both cases.
  let timeout: ReturnType<typeof setTimeout> | null;

  return function <U> (this: U, ...args: Parameters<typeof callback>) {
    const context = this;
    const later = () => {
      timeout = null;

      if (!immediate) {
        callback.apply(context, args);
      }
    };
    const callNow = immediate && !timeout;

    if (typeof timeout === "number") {
      clearTimeout(timeout);
    }

    timeout = setTimeout(later, wait);

    if (callNow) {
      callback.apply(context, args);
    }
  };
}